exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-type[data-v-1c72cbdb]{padding:2px 12px;font-size:13px}.head-box[data-v-1c72cbdb]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.head-box .input[data-v-1c72cbdb]{width:240px;margin:0 20px 0 10px}.assess-right[data-v-1c72cbdb]{margin-left:20px}\n", ""]);

// exports
